<template>
  <div class="height-100 d-flex">
    <div class="authCard m-auto">
      <img src="@/assets/smart-stewards.png" class="header-logo" height="85" width="85" alt="Logo">
      <h3>Reset Password</h3>
      <form class="auth-form" @submit="reset">
        <div class="form-group">
          <input type="password" v-model="password" placeholder="New Password" class="form-control"
          required>
        </div>

         <div class="form-group">
          <input type="password" v-model="confirm_password" placeholder="Confirm Password"
          class="form-control" required>
          <p v-if="error" class="error-msg"></p>
        </div>

        <div>
          <button class="btn primary-btn btn-block" :disabled="isDisabled">
            <span v-if="!loading"> Reset </span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['token'],
  computed: {
    isDisabled() {
      if (!this.password || !this.confirm_password) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      password: '',
      confirm_password: '',
      loading: false,
      error: false,
    };
  },
  methods: {
    async reset(e) {
      e.preventDefault();
      this.loading = true;
      try {
        const data = { password: this.password, token: this.token };
        const url = `${this.$baseUrl}/password/reset`;
        const res = await this.$http({ url, data, method: 'POST' });
        this.$toast.open(res.data.message, {
          duration: 2500,
          type: 'success',
          dismissible: true,
        });
        setTimeout(() => {
          this.$router.push('/signin');
        }, 1500);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.response.data.message, {
          duration: 2500,
          type: 'error',
          dismissible: true,
        });
        console.log(error.response);
      }
    },
  },
};
</script>

<style scoped>
  .d-flex{
    background-color: #FFF;
  }
</style>
